import { render, staticRenderFns } from "./viewpatients.vue?vue&type=template&id=62234c28&scoped=true&"
import script from "./viewpatients.vue?vue&type=script&lang=js&"
export * from "./viewpatients.vue?vue&type=script&lang=js&"
import style0 from "./viewpatients.vue?vue&type=style&index=0&id=62234c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62234c28",
  null
  
)

export default component.exports